// firebase.js
import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

// Your web app's Firebase configuration (replace with your actual config)
const firebaseConfig = {
  apiKey: 'AIzaSyC58FNncIhEhX-Fdq7i3tq6LgLzaP62AjM',
  authDomain: 'nss-lms.firebaseapp.com',
  databaseURL: 'https://nss-lms-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'nss-lms',
  storageBucket: 'nss-lms.firebasestorage.app',
  messagingSenderId: '649250501983',
  appId: '1:649250501983:web:9d00c47298033bd1acb2ea',
  measurementId: 'G-CQD0KJVSJL',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app)

export { database }
